import axios from 'axios'
import { Message } from 'element-ui'
import store from '@/store'

const url = process.env.VUE_APP_API_URL

const http = axios.create({
	withCredentials: true,
	baseURL: url || '/',
	timeout: 30000
})

const showStatus = (status) => {
	console.log(14, status)
	let message = ''
	switch (status) {
		case 400:
			message = '请求错误(400)'
			break
		case 401:
			message = '未授权，请重新登录(401)'
			break
		case 402:
			message = '拒绝访问(402)'
			break
		case 404:
			message = '请求出错(404)'
			break
		case 408:
			message = '请求超时(408)'
			break
		case 500:
			message = '服务器错误(500)'
			break
		case 501:
			message = '服务未实现(501)'
			break
		case 502:
			message = '网络错误(502)'
			break
		case 503:
			message = '服务不可用(503)'
			break
		case 504:
			message = '网络超时(504)'
			break
		case 505:
			message = 'HTTP版本不受支持(505)'
			break
		default:
			message = `连接出错(${status})!`
	}
	return `${message}，请检查网络或联系管理员！`
}
// 请求拦截器
http.interceptors.request.use(
	config => {
		// 配置请求头
		config.headers = {
			'Content-Type': 'application/json;charset=UTF-8',
			...config.headers,
			authorization: store.state.token,
			// tenantId: store.state.tenantId,
			// 'Content-Type':'application/x-www-form-urlencoded', //传参方式表单Form Data格式
		}
		return config
	},
	error => {
		return Promise.reject(error)
	}
)

// 响应拦截器
http.interceptors.response.use(
	response => {
		const status = response.status
		let message = ''
		// eslint-disable-next-line no-mixed-operators
		if (status < 200 || status >= 300 && status !== 401 && status !== 500) {
			// 处理http错误，抛到业务代码
			message = showStatus(status)
			if (typeof response.data === 'string') {
				response.data = { message }
			} else {
				response.data.message = message
			}
			return response
		} else if (status === 200) {
			// code==0 接口请求成功
			const { code, msg } = response.data
			// 为了兼容之前的写法，返回response
			if (+code === 200) {
				return response.data
			}
			Message.error(msg)
			return Promise.reject(code)
		} else if (status === 500) {
			message = showStatus(status)
			response.data = { message: message }
			return response
		}
	},
	(err) => {
		err.message = '请求超时或服务器异常，请检查网络或联系管理员！'
		Message.error(err.message)
		return Promise.reject(err)
	}
)

export default http



// WEBPACK FOOTER //
// ./src/utils/http.js